import React from 'react';
import cn from '@/utils/cn';
import { iconVariant } from './iconVariant';
import { IconProps } from './types/IconInterface';

const ArrowUpOutlineIcon = ({ size, variant, className }: IconProps) => (
  <svg
    className={cn(iconVariant({ variant, size, className }))}
    viewBox="0 0 5 5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      d="M3.64796 1.91993L2.30396 0.575928L0.959961 1.91993M2.30396 0.575928V4.03193"
      stroke="currentColor"
      strokeWidth="0.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowUpOutlineIcon;
